import React, { useEffect, useState } from "react";
import AvailableCoupons from "../available-coupons/available-coupons";
import AvailblePoints from "../available-points/available-points";
import { CircularProgress } from "@mui/material";
import "../../styles/redeem-loyalty/redeem-loyatly.scss";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import OTPButton from "../request-otp/requestotp";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

const Redeemloyalty = ({ loyaltyData, loyaltyInfo }) => {
  const [couponPoints, setCouponPoints] = useState(false);
  const [couponCode, setCouponCode] = useState(false);
  const [isWcoupon, setIsWcoupon] = useState(false);
  const [otpScreen, setOtpScreen] = useState(false);
  const [copyUnsedCoupon, setCopyUnusedCoupon] = useState(false);

  useEffect(() => {
    const waitTime = 3 * 60 * 1000;

    const timerInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      const storedTime = parseInt(localStorage.getItem("initialTime"), 10);
      const elapsedTime = currentTime - storedTime;

      if (elapsedTime >= waitTime) {
        localStorage.clear();
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  const woocommerceCoupons = (val) => {
    setIsWcoupon(val);
  };

  const wooCommerceUnusedCoupon = (val) => {
    setCopyUnusedCoupon(val);
  };

  const receiveCouponPoints = (points) => {
    setCouponPoints(points);
  };

  const reveiveCouponCode = (code) => {
    setCouponCode(code);
  };

  const handleEditMobile = () => {
    localStorage.clear();
    setOtpScreen(true);
  };

  const handleProfile = () => {
    window.open(`${loyaltyInfo?.registration_link}`, "_blank");
  };

  return (
    <div style={{ position: "relative" }}>
      {otpScreen ? (
        <OTPButton />
      ) : (
        <div>
          <div className="edit-mobile-container-redeem-loyalty">
            <div>
              <h3 style={{ color: "#413C49" }}>Claim Your Loyalty Points</h3>
            </div>
            <div className="" style={{ display: "flex", marginBottom: "10px", marginTop: "10px", marginRight: "30px" }}>
              <button
                onClick={handleEditMobile}
                style={{
                  height: "38px",
                  width: "170px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                  backgroundColor: "#EEEAF4",
                  border: "none",
                  borderRadius: "5px",
                  position: "relative",
                }}
              >{` +${loyaltyInfo?.details?.country_code}  ${loyaltyInfo?.details?.mobile}`}</button>
              <button
                onClick={handleEditMobile}
                style={{
                  height: "38px",
                  width: "40px",
                  cursor: "pointer",
                  backgroundColor: "var(--primary-color)",
                  border: "none",
                  borderRadius: "8px",
                  position: "relative",
                }}
              >
                <BorderColorIcon
                  className="edit-mobile-icon"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fill: "var(--secondary-color)",
                  }}
                />
              </button>
              {loyaltyInfo?.registration_link ? (
                <button
                  onClick={handleProfile}
                  style={{
                    height: "38px",
                    width: "40px",
                    backgroundColor: "var(--primary-color)",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "6px",
                    marginLeft: "6px",
                    position: "relative",
                  }}
                >
                  <AccountBoxIcon
                    className="edit-mobile-icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      fill: "var(--secondary-color)",
                    }}
                  />
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
          {!loyaltyInfo ? (
            <CircularProgress sx={{ color: "var(--primary-color)" }} />
          ) : (
            <div>
              <div className="main-container">
                <AvailableCoupons wooCommerceUnusedCoupon={wooCommerceUnusedCoupon} loyaltyInfo={loyaltyInfo} loyaltyData={loyaltyData} couponPoints={couponPoints} reveiveCouponCode={reveiveCouponCode} woocommerceCoupons={woocommerceCoupons} isWcoupon={isWcoupon} />
                <AvailblePoints loyaltyInfo={loyaltyInfo} loyaltyData={loyaltyData} receiveCouponPoints={receiveCouponPoints} couponCode={couponCode} woocommerceCoupons={woocommerceCoupons} isWcoupon={isWcoupon} />
              </div>
              {isWcoupon || copyUnsedCoupon ? (
                <h4 className="notetext">
                  <span style={{ color: "var(--primary-color)" }}>Note: </span>
                  Once you've redeemed your points or coupons, get the code and input it in the coupon field before completing your purchase to receive the discount.
                </h4>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Redeemloyalty;
